import React, { useState, useContext, useEffect } from "react";
// import BillingCard from "./BillingCard";
import { RootContext } from "../../RootContextProvider";
import BillingFeature from "./BillingFeature";
import { Button, Switch } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import { loadStripe } from "@stripe/stripe-js";
import {
  fetchCheckoutSession,
  fetchCustomerPortalSession,
} from "../../utils/stripe";
import "./Billing.css";
import { defineCustomerPlanID } from "../../utils/utils";
import BillingFAQ from "./BillingFAQ";
import { getCurrentPlan } from "../../utils/utils";

const stripePromise = loadStripe(
  "pk_live_51HjiqaGa6jhml1bVxDXK3Me3IQ8FIkCUR5shhBHcPN5NDzUgu4KmJFq6hKtWc4vqPTPryIE2lQxfJT9EaBNWRIIM00yr97kaLi"
);

const Billing = () => {
  const { account, user } = useContext(RootContext);
  const [isAnnual, setIsAnnual] = useState(false);
  const [, setLoadingPortal] = useState(false);
  const [currentPlan, setCurrentPlan] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setCurrentPlan(
      account.IsPaying ? getCurrentPlan(account.PlanID) : "GRATUIT"
    );
    setLoading(false);
    // eslint-disable-next-line
  }, []);
  const handleNewCheckoutSession = async (plan) => {
    console.log("clicked");
    const { sessionId } = await fetchCheckoutSession(
      defineCustomerPlanID(plan, isAnnual ? "yearly" : "monthly"),
      user.Email,
      null
    );
    // When the customer clicks on the button, redirect them to Checkout.
    const stripe = await stripePromise;
    await stripe.redirectToCheckout({
      sessionId,
    });
  };

  const handleClickPaid = async (plan) => {
    if (!account.CustomerID || !account.IsPaying) {
      await handleNewCheckoutSession(plan);
    } else {
      setLoadingPortal(true);
      let portalURL = await fetchCustomerPortalSession(account.CustomerID);
      console.log(portalURL);
      setLoadingPortal(false);
      window.location.replace(portalURL.url);
    }
  };

  if (loading) {
    return <></>;
  } else {
    return (
      <div className="billing-container">
        {!account.IsPaying ? (
          <>
            <div className="billing-intro">
              Testez le plan premium{" "}
              <span style={{ textDecoration: "underline" }}>gratuitement</span>{" "}
              pendant 7 jours.
            </div>
            <div className="billing-intro small">
              Passez à la vitesse supérieure dès maintenant.
            </div>
          </>
        ) : (
          ""
        )}
        <div className="billing-switch">
          <div
            className={
              isAnnual
                ? "switch-description switch-selected"
                : "switch-description"
            }
          >
            Annuel (2 mois offerts)
          </div>
          <Switch
            className="default-green"
            defaultChecked
            onChange={() => {
              setIsAnnual(!isAnnual);
            }}
          />
          <div
            className={
              isAnnual
                ? "switch-description"
                : "switch-description switch-selected"
            }
          >
            Mensuel
          </div>
        </div>
        <div className="billing-cards">
          {!account.IsPaying || !account.CustomerID ? (
            <div
              className="block-section"
              style={{
                boxShadow: "0px 4px 25px rgba(0, 0, 0, 0.05)",
                minHeight: "550px",
                position: "relative",
              }}
            >
              <div className="plan-name" style={{ color: "#CFCFEB" }}>
                GRATUIT
              </div>
              <div className="plan-price" style={{ color: "#CFCFEB" }}>
                0€<span>{isAnnual ? "/an" : "/mois"}</span>
              </div>
              <div className="plan-features">
                <BillingFeature
                  hasFeature={true}
                  detail="1 page personnalisable"
                />
                <BillingFeature hasFeature={true} detail="Jusqu'à 5 liens" />
                <BillingFeature
                  hasFeature={false}
                  detail="Enlever logo Linksight"
                />
                <BillingFeature
                  hasFeature={false}
                  detail="Statistiques avancées"
                />
                <BillingFeature
                  hasFeature={false}
                  detail="Planification de liens"
                />
                <BillingFeature
                  hasFeature={false}
                  detail="Accès à tous les blocs"
                />
                <BillingFeature
                  hasFeature={false}
                  detail="Accès à tous les styles"
                />

                <BillingFeature
                  hasFeature={false}
                  detail="Google Analytics et FB Pixel"
                />
              </div>
              {account.Admin ? (
                <div className="plan-cta">
                  {" "}
                  {!account.IsPaying ? (
                    <Button
                      className="current-plan-btn"
                      htmlType="submit"
                      // onClick={() => {
                      //   handleClickPaid();
                      // }}
                      size="large"
                    >
                      Votre plan actuel
                    </Button>
                  ) : (
                    <Button
                      className="current-plan-btn"
                      htmlType="submit"
                      onClick={() => {
                        handleClickPaid();
                      }}
                      size="large"
                    >
                      Gérer abonnement
                    </Button>
                  )}
                </div>
              ) : (
                ""
              )}
            </div>
          ) : (
            ""
          )}
          <div
            className="block-section"
            style={{
              boxShadow: "0px 4px 25px rgba(77, 97, 252, 0.5)",
              padding: "0px",
              minHeight: "550px",
              position: "relative",
            }}
          >
            <div className="best-seller">
              Meilleure vente{" "}
              <span role="img" aria-label="emoji">
                🏆
              </span>
            </div>
            <div style={{ padding: "10px 20px 20px 20px" }}>
              <div className="plan-name">PREMIUM</div>
              <div className="plan-price">
                {isAnnual ? (
                  <>
                    69€<span>/an</span>
                  </>
                ) : (
                  <>
                    6,99€<span>/mois</span>
                  </>
                )}
              </div>
              <span role="img" aria-label="emoji">
                Sans aucun engagement 🥰
              </span>
              <div className="plan-features">
                <BillingFeature hasFeature={true} detail="Liens illimités" />
                <BillingFeature
                  hasFeature={true}
                  detail="Enlever logo Linksight"
                />
                <BillingFeature
                  hasFeature={true}
                  detail="Statistiques avancées"
                />
                <BillingFeature
                  hasFeature={true}
                  detail="5 pages personnalisables"
                />
                <BillingFeature
                  hasFeature={true}
                  detail="Planification de liens"
                />
                <BillingFeature
                  hasFeature={true}
                  detail="Accès à tous les blocs"
                />
                <BillingFeature
                  hasFeature={true}
                  detail="Accès à tous les styles"
                />
                <BillingFeature
                  hasFeature={true}
                  detail="Google Analytics et FB Pixel"
                />
              </div>
              {account.Admin ? (
                <div className="plan-cta">
                  {" "}
                  <Button
                    className="submit-link"
                    htmlType="submit"
                    onClick={() => {
                      handleClickPaid("premium");
                    }}
                    size="large"
                  >
                    {currentPlan.includes("Premium") ? (
                      "Votre plan actuel"
                    ) : (
                      <>
                        {" "}
                        Testez gratuitement <ArrowRightOutlined />
                      </>
                    )}
                  </Button>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
          <div
            className="block-section"
            style={{
              boxShadow: "0px 4px 25px rgba(0, 0, 0, 0.05)",
              minHeight: "550px",
              position: "relative",
            }}
          >
            <div className="plan-name">AGENCE</div>
            <div className="plan-price">
              {isAnnual ? (
                <>
                  590€<span>/an</span>
                </>
              ) : (
                <>
                  59€<span>/mois</span>
                </>
              )}
            </div>

            {/* <div className="sub-price">Offre personnalisée</div> */}
            <div className="plan-features">
              <BillingFeature
                hasFeature={true}
                detail="50 pages personnalisables"
              />
              <BillingFeature hasFeature={true} detail="Liens illimités" />
              <BillingFeature
                hasFeature={true}
                detail="Tous les features premium"
              />
              <BillingFeature hasFeature={true} detail="Support via chat" />
            </div>
            {account.Admin ? (
              <div className="plan-cta">
                <Button
                  className="submit-link agency"
                  htmlType="submit"
                  onClick={() => {
                    handleClickPaid("agency");
                  }}
                  size="large"
                >
                  {currentPlan.includes("Agence") ? (
                    "Votre plan actuel"
                  ) : (
                    <>
                      {" "}
                      Passer au plan agence <ArrowRightOutlined />
                    </>
                  )}
                </Button>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
        <div className="faq-section block-section">
          <BillingFAQ />
        </div>
      </div>
    );
  }
};

export default Billing;
